/* eslint max-nested-callbacks: ["error", 8] */
'use strict';

var _slicedToArray = require("/home/richard/status/chat/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");

var promisify = require('promisify-es6');

var _require = require('ipld-dag-pb'),
    DAGNode = _require.DAGNode,
    DAGLink = _require.DAGLink;

var CID = require('cids');

var map = require('async/map');

var mapSeries = require('async/mapSeries');

var series = require('async/series');

var parallel = require('async/parallel');

var eachLimit = require('async/eachLimit');

var waterfall = require('async/waterfall');

var someLimit = require('async/someLimit');

var setImmediate = require('async/setImmediate');

var _require2 = require('interface-datastore'),
    Key = _require2.Key;

var errCode = require('err-code');

var createPinSet = require('./pin-set');

var _require3 = require('../utils'),
    resolvePath = _require3.resolvePath; // arbitrary limit to the number of concurrent dag operations


var concurrencyLimit = 300;
var pinDataStoreKey = new Key('/local/pins');

function toB58String(hash) {
  return new CID(hash).toBaseEncodedString();
}

function invalidPinTypeErr(type) {
  var errMsg = "Invalid type '".concat(type, "', must be one of {direct, indirect, recursive, all}");
  return errCode(new Error(errMsg), 'ERR_INVALID_PIN_TYPE');
}

module.exports = function (self) {
  var repo = self._repo;
  var dag = self.dag;
  var pinset = createPinSet(dag);
  var types = {
    direct: 'direct',
    recursive: 'recursive',
    indirect: 'indirect',
    all: 'all'
  };
  var directPins = new Set();
  var recursivePins = new Set();

  var directKeys = function directKeys() {
    return Array.from(directPins).map(function (key) {
      return new CID(key).buffer;
    });
  };

  var recursiveKeys = function recursiveKeys() {
    return Array.from(recursivePins).map(function (key) {
      return new CID(key).buffer;
    });
  };

  function getIndirectKeys(callback) {
    var indirectKeys = new Set();
    eachLimit(recursiveKeys(), concurrencyLimit, function (multihash, cb) {
      dag._getRecursive(multihash, function (err, nodes) {
        if (err) {
          return cb(err);
        }

        nodes.map(function (_ref) {
          var multihash = _ref.multihash;
          return toB58String(multihash);
        }) // recursive pins pre-empt indirect pins
        .filter(function (key) {
          return !recursivePins.has(key);
        }).forEach(function (key) {
          return indirectKeys.add(key);
        });
        cb();
      });
    }, function (err) {
      if (err) {
        return callback(err);
      }

      callback(null, Array.from(indirectKeys));
    });
  } // Encode and write pin key sets to the datastore:
  // a DAGLink for each of the recursive and direct pinsets
  // a DAGNode holding those as DAGLinks, a kind of root pin


  function flushPins(callback) {
    var dLink, rLink, root;
    series([// create a DAGLink to the node with direct pins
    function (cb) {
      return waterfall([function (cb) {
        return pinset.storeSet(directKeys(), cb);
      }, function (node, cb) {
        return DAGLink.create(types.direct, node.size, node.multihash, cb);
      }, function (link, cb) {
        dLink = link;
        cb(null);
      }], cb);
    }, // create a DAGLink to the node with recursive pins
    function (cb) {
      return waterfall([function (cb) {
        return pinset.storeSet(recursiveKeys(), cb);
      }, function (node, cb) {
        return DAGLink.create(types.recursive, node.size, node.multihash, cb);
      }, function (link, cb) {
        rLink = link;
        cb(null);
      }], cb);
    }, // the pin-set nodes link to a special 'empty' node, so make sure it exists
    function (cb) {
      return DAGNode.create(Buffer.alloc(0), function (err, empty) {
        if (err) {
          return cb(err);
        }

        dag.put(empty, {
          cid: new CID(empty.multihash),
          preload: false
        }, cb);
      });
    }, // create a root node with DAGLinks to the direct and recursive DAGs
    function (cb) {
      return DAGNode.create(Buffer.alloc(0), [dLink, rLink], function (err, node) {
        if (err) {
          return cb(err);
        }

        root = node;
        dag.put(root, {
          cid: new CID(root.multihash),
          preload: false
        }, cb);
      });
    }, // hack for CLI tests
    function (cb) {
      return repo.closed ? repo.open(cb) : cb(null, null);
    }, // save root to datastore under a consistent key
    function (cb) {
      return repo.datastore.put(pinDataStoreKey, root.multihash, cb);
    }], function (err, res) {
      if (err) {
        return callback(err);
      }

      self.log("Flushed pins with root: ".concat(root));
      return callback(null, root);
    });
  }

  var pin = {
    add: promisify(function (paths, options, callback) {
      if (typeof options === 'function') {
        callback = options;
        options = {};
      }

      options = options || {};
      var recursive = options.recursive == null ? true : options.recursive;
      resolvePath(self.object, paths, function (err, mhs) {
        if (err) {
          return callback(err);
        } // verify that each hash can be pinned


        map(mhs, function (multihash, cb) {
          var key = toB58String(multihash);

          if (recursive) {
            if (recursivePins.has(key)) {
              // it's already pinned recursively
              return cb(null, key);
            } // entire graph of nested links should be pinned,
            // so make sure we have all the objects


            dag._getRecursive(key, {
              preload: options.preload
            }, function (err) {
              if (err) {
                return cb(err);
              } // found all objects, we can add the pin


              return cb(null, key);
            });
          } else {
            if (recursivePins.has(key)) {
              // recursive supersedes direct, can't have both
              return cb(new Error("".concat(key, " already pinned recursively")));
            }

            if (directPins.has(key)) {
              // already directly pinned
              return cb(null, key);
            } // make sure we have the object


            dag.get(new CID(multihash), {
              preload: options.preload
            }, function (err) {
              if (err) {
                return cb(err);
              } // found the object, we can add the pin


              return cb(null, key);
            });
          }
        }, function (err, results) {
          if (err) {
            return callback(err);
          } // update the pin sets in memory


          var pinset = recursive ? recursivePins : directPins;
          results.forEach(function (key) {
            return pinset.add(key);
          }); // persist updated pin sets to datastore

          flushPins(function (err, root) {
            if (err) {
              return callback(err);
            }

            return callback(null, results.map(function (hash) {
              return {
                hash: hash
              };
            }));
          });
        });
      });
    }),
    rm: promisify(function (paths, options, callback) {
      var recursive = true;

      if (typeof options === 'function') {
        callback = options;
      } else if (options && options.recursive === false) {
        recursive = false;
      }

      resolvePath(self.object, paths, function (err, mhs) {
        if (err) {
          return callback(err);
        } // verify that each hash can be unpinned


        map(mhs, function (multihash, cb) {
          pin._isPinnedWithType(multihash, types.all, function (err, res) {
            if (err) {
              return cb(err);
            }

            var pinned = res.pinned,
                reason = res.reason;
            var key = toB58String(multihash);

            if (!pinned) {
              return cb(new Error("".concat(key, " is not pinned")));
            }

            switch (reason) {
              case types.recursive:
                if (recursive) {
                  return cb(null, key);
                } else {
                  return cb(new Error("".concat(key, " is pinned recursively")));
                }

              case types.direct:
                return cb(null, key);

              default:
                return cb(new Error("".concat(key, " is pinned indirectly under ").concat(reason)));
            }
          });
        }, function (err, results) {
          if (err) {
            return callback(err);
          } // update the pin sets in memory


          results.forEach(function (key) {
            if (recursive && recursivePins.has(key)) {
              recursivePins.delete(key);
            } else {
              directPins.delete(key);
            }
          }); // persist updated pin sets to datastore

          flushPins(function (err, root) {
            if (err) {
              return callback(err);
            }

            self.log("Removed pins: ".concat(results));
            return callback(null, results.map(function (hash) {
              return {
                hash: hash
              };
            }));
          });
        });
      });
    }),
    ls: promisify(function (paths, options, callback) {
      var type = types.all;

      if (typeof paths === 'function') {
        callback = paths;
        options = null;
        paths = null;
      }

      if (typeof options === 'function') {
        callback = options;
      }

      if (paths && paths.type) {
        options = paths;
        paths = null;
      }

      if (options && options.type) {
        if (typeof options.type !== 'string') {
          return setImmediate(function () {
            return callback(invalidPinTypeErr(options.type));
          });
        }

        type = options.type.toLowerCase();
      }

      if (!Object.keys(types).includes(type)) {
        return setImmediate(function () {
          return callback(invalidPinTypeErr(type));
        });
      }

      if (paths) {
        // check the pinned state of specific hashes
        resolvePath(self.object, paths, function (err, mhs) {
          if (err) {
            return callback(err);
          }

          mapSeries(mhs, function (multihash, cb) {
            pin._isPinnedWithType(multihash, types.all, function (err, res) {
              if (err) {
                return cb(err);
              }

              var pinned = res.pinned,
                  reason = res.reason;
              var key = toB58String(multihash);

              if (!pinned) {
                return cb(new Error("Path ".concat(key, " is not pinned")));
              }

              switch (reason) {
                case types.direct:
                case types.recursive:
                  return cb(null, {
                    hash: key,
                    type: reason
                  });

                default:
                  return cb(null, {
                    hash: key,
                    type: "".concat(types.indirect, " through ").concat(reason)
                  });
              }
            });
          }, callback);
        });
      } else {
        // show all pinned items of type
        var pins = [];

        if (type === types.direct || type === types.all) {
          pins = pins.concat(Array.from(directPins).map(function (hash) {
            return {
              type: types.direct,
              hash: hash
            };
          }));
        }

        if (type === types.recursive || type === types.all) {
          pins = pins.concat(Array.from(recursivePins).map(function (hash) {
            return {
              type: types.recursive,
              hash: hash
            };
          }));
        }

        if (type === types.indirect || type === types.all) {
          getIndirectKeys(function (err, indirects) {
            if (err) {
              return callback(err);
            }

            pins = pins // if something is pinned both directly and indirectly,
            // report the indirect entry
            .filter(function (_ref2) {
              var hash = _ref2.hash;
              return !indirects.includes(hash) || indirects.includes(hash) && !directPins.has(hash);
            }).concat(indirects.map(function (hash) {
              return {
                type: types.indirect,
                hash: hash
              };
            }));
            return callback(null, pins);
          });
        } else {
          return callback(null, pins);
        }
      }
    }),
    _isPinnedWithType: promisify(function (multihash, type, callback) {
      var key = toB58String(multihash);
      var recursive = types.recursive,
          direct = types.direct,
          all = types.all; // recursive

      if ((type === recursive || type === all) && recursivePins.has(key)) {
        return callback(null, {
          pinned: true,
          reason: recursive
        });
      }

      if (type === recursive) {
        return callback(null, {
          pinned: false
        });
      } // direct


      if ((type === direct || type === all) && directPins.has(key)) {
        return callback(null, {
          pinned: true,
          reason: direct
        });
      }

      if (type === direct) {
        return callback(null, {
          pinned: false
        });
      } // indirect (default)
      // check each recursive key to see if multihash is under it
      // arbitrary limit, enables handling 1000s of pins.


      var foundPin;
      someLimit(recursiveKeys(), concurrencyLimit, function (key, cb) {
        dag.get(new CID(key), function (err, res) {
          if (err) {
            return cb(err);
          }

          pinset.hasDescendant(res.value, multihash, function (err, has) {
            if (has) {
              foundPin = toB58String(res.value.multihash);
            }

            cb(err, has);
          });
        });
      }, function (err, found) {
        if (err) {
          return callback(err);
        }

        return callback(null, {
          pinned: found,
          reason: foundPin
        });
      });
    }),
    _load: promisify(function (callback) {
      waterfall([// hack for CLI tests
      function (cb) {
        return repo.closed ? repo.datastore.open(cb) : cb(null, null);
      }, function (_, cb) {
        return repo.datastore.has(pinDataStoreKey, cb);
      }, function (has, cb) {
        return has ? cb() : cb(new Error('No pins to load'));
      }, function (cb) {
        return repo.datastore.get(pinDataStoreKey, cb);
      }, function (mh, cb) {
        return dag.get(new CID(mh), '', {
          preload: false
        }, cb);
      }], function (err, pinRoot) {
        if (err) {
          if (err.message === 'No pins to load') {
            self.log('No pins to load');
            return callback();
          } else {
            return callback(err);
          }
        }

        parallel([function (cb) {
          return pinset.loadSet(pinRoot.value, types.recursive, cb);
        }, function (cb) {
          return pinset.loadSet(pinRoot.value, types.direct, cb);
        }], function (err, keys) {
          if (err) {
            return callback(err);
          }

          var _keys = _slicedToArray(keys, 2),
              rKeys = _keys[0],
              dKeys = _keys[1];

          directPins = new Set(dKeys.map(toB58String));
          recursivePins = new Set(rKeys.map(toB58String));
          self.log('Loaded pins from the datastore');
          return callback(null);
        });
      });
    })
  };
  return pin;
};